import {notification} from "antd";
import {CheckOutlined, WarningOutlined} from "@ant-design/icons";

export  function SuccessNotification(description = '', message = "موفق",) {
    notification.open({
        message,
        description,
        icon: (
            <CheckOutlined
                style={{
                    color: 'green',
                }}
            />
        ),
    });
}

export  function ErrorNotification(description = '', message = "خطا") {
    notification.open({
        message,
        description,
        icon: (
            <WarningOutlined
                style={{
                    color: 'red',
                }}
            />
        ),
    });
}